import React from 'react';
import { SInput } from './styled';
import { InputProps } from './types';

export const Input: React.FC<InputProps> = ({ onChange, ...args }) => {
  return <SInput {...args} onChange={(e) => onChange && onChange(e.target.value)} />;
};
